import React from "react";
import { PreservedAres } from "../features";
import { Grid } from "@material-ui/core";

function PreservedAresPage() {
  return (
    <>

        <PreservedAres.Container />

    </>
  );
}

export default PreservedAresPage;
